module.exports = __webpack_public_path__ + "media/images/lb/133-b0fa333a26fe3a36f4f2303b0f96de1e.svg";